import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createManualLead, getCallLeadByPhone, getCallLeads, updateCallLead } from '../api/callCenterApi';
import { queryKeys } from '../api/queryKeys';

export function useCallLeads(params = {}, options = {}) {
  return useQuery({
    queryKey: queryKeys.callLeads(params),
    queryFn: () => getCallLeads(params),
    ...options
  });
}

export function useCallLeadByPhone(phone, options = {}) {
  return useQuery({
    queryKey: queryKeys.callLeadByPhone(phone),
    queryFn: () => getCallLeadByPhone(phone),
    enabled: Boolean(phone) && options.enabled !== false,
    ...options
  });
}

export function useCreateManualLead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createManualLead,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['call-leads'] })
  });
}

export function useUpdateCallLead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ recordId, fields }) => updateCallLead(recordId, fields),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['call-leads'] })
  });
}
